import { getRandomIntInclusive, useRouter } from '@application/utils';
import {
  Banner,
  Button,
  CardItemArticle,
  Container,
  PromoNewsletter,
  SectionCardItemSlider,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import { TbShare } from 'react-icons/tb';
import type { ArticlePageProps } from '..';
import bannerBackgroundImage from './assets/banner-background-image.svg';
import bannerImage from './assets/banner-image.svg';
import separatorBlueBottom from './assets/marker-section-bot.svg';
import * as Styled from './styled';

export * from './types';

export const ArticlePage: FC<ArticlePageProps> = (props) => {
  const { translate } = useTranslation();
  const { navigateToRoute } = useRouter();
  const {
    contentHtml,
    header,
    loading,
    newsletter,
    articleItems = [],
    moreArticleLink,
    onSocialShareClick,
  } = props;

  const articleCards = useMemo(() => {
    if (loading) {
      return Array(getRandomIntInclusive(1, 3))
        .fill(undefined)
        .map((_, index) => (
          <CardItemArticle style={{ height: 351 }} title="" key={index} loading />
        ));
    }
    return articleItems.map((item, index) => (
      <CardItemArticle style={{ height: 351 }} key={index} {...item} />
    ));
  }, [articleItems, loading]);

  return (
    <>
      <Styled.HeaderWrapper>
        <Styled.StyledHeaderProfile {...header}>
          <Styled.ShareWrapper>
            <Button
              shrink
              color="dark"
              iconLeft={<TbShare />}
              size="small"
              onClick={onSocialShareClick}
            >
              {translate('common.buttons.share')}
            </Button>
          </Styled.ShareWrapper>
        </Styled.StyledHeaderProfile>
        <Styled.SeparatorBottom src={separatorBlueBottom} />
      </Styled.HeaderWrapper>

      <Container>
        {!!contentHtml && <Styled.Content dangerouslySetInnerHTML={{ __html: contentHtml }} />}

        <Styled.BannerWrapper>
          <Banner
            title={translate('common.banners.explorePuppies.title')}
            btnText={translate('common.buttons.discover')}
            theme="blue"
            backgroundImage={bannerBackgroundImage}
            image={bannerImage}
            onClick={() => navigateToRoute('litterList')}
          />
        </Styled.BannerWrapper>
      </Container>

      {!!newsletter && <PromoNewsletter {...newsletter} />}
      {articleItems?.length && (
        <Container>
          <Styled.VerticalMargin>
            <SectionCardItemSlider
              title={translate('articleList.otherPosts')}
              loading={loading}
              items={articleCards}
              showMoreLink={moreArticleLink}
            />
          </Styled.VerticalMargin>
        </Container>
      )}
    </>
  );
};
